import React, { FC, Fragment, useState } from 'react';
import { formatDate } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { Order } from 'models/order';
import { Box, Button, Typography } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SchedulePickupFromTruckDialog from 'components/shared/schedule-pickup-from-truck-dialog/schedule-pickup-from-truck-dialog.component';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type PickUpActionsProps = { order: Order };
const PickUpActions: FC<PickUpActionsProps> = ({ order }: PickUpActionsProps) => {
    const { t: translate } = useTranslation(['common', 'transport']);
    const [pickupDialogOpen, setPickupDialogOpen] = useState(false);

    const handleCloseDialog = () => {
        setPickupDialogOpen(false);
    };

    return (
        <Fragment>
            {order.currentPickup ? (
                <Box display="flex" alignItems="center">
                    <Box mr={1}>
                        <CheckCircleIcon color="success" />
                    </Box>
                    <Box flexGrow={1}>
                        <Box>
                            <Typography variant="subtitle2">{translate('transport:PICKUP_ORDERED')}</Typography>
                        </Box>
                        <Box>{formatDate(new Date(order.currentPickup.transportDate), 'date')}</Box>
                    </Box>
                    <Box>
                        <Button onClick={() => setPickupDialogOpen(true)} data-test="pickup-actions.show-pickup-btn">
                            {translate('common:SHOW')}
                        </Button>
                    </Box>
                </Box>
            ) : (
                <Box>
                    <Button
                        fullWidth
                        variant="contained"
                        startIcon={<LocalShippingIcon />}
                        disableElevation
                        onClick={() => setPickupDialogOpen(true)}
                        data-test="pickup-actions.pickup-from-clinic-btn"
                    >
                        {translate('transport:PICKUP_FROM_CLINIC')}
                    </Button>
                </Box>
            )}

            {pickupDialogOpen ? (
                <SchedulePickupFromTruckDialog
                    open={pickupDialogOpen}
                    onClose={handleCloseDialog}
                    orderId={order._id}
                />
            ) : undefined}
        </Fragment>
    );
};

export default PickUpActions;
